var $54b47fc030b7b21e$exports = {};
// var range = document.querySelector(".slider-range");
// var imageAfter = document.querySelector(".slider-image-after");
// var separator = document.querySelector(".slider-separator");
// var handler = document.querySelector(".slider-handler");
// var updatePosition = function () {
//   var position = range.value + "%";
//   imageAfter.style.width = position;
//   separator.style.left = position;
// };
// range.addEventListener("input", updatePosition);
var $54b47fc030b7b21e$var$range = document.querySelector(".slider-range");
var $54b47fc030b7b21e$var$imageAfter = document.querySelector(".slider-image-after");
var $54b47fc030b7b21e$var$separator = document.querySelector(".slider-separator");
var $54b47fc030b7b21e$var$handler = document.querySelector(".slider-handler");
var $54b47fc030b7b21e$var$updatePosition = function() {
    var rawValue = parseInt($54b47fc030b7b21e$var$range.value);
    var minLimit = 7;
    var maxLimit = 93;
    var limitedValue = Math.max(minLimit, Math.min(rawValue, maxLimit));
    if (limitedValue !== rawValue) $54b47fc030b7b21e$var$range.value = limitedValue;
    var position = limitedValue + "%";
    $54b47fc030b7b21e$var$imageAfter.style.width = position;
    $54b47fc030b7b21e$var$separator.style.left = position;
    $54b47fc030b7b21e$var$handler.classList.remove("slider-handler-left", "slider-handler-middle", "slider-handler-right");
    if (limitedValue < 40) $54b47fc030b7b21e$var$handler.classList.add("slider-handler-left");
    else if (limitedValue > 60) $54b47fc030b7b21e$var$handler.classList.add("slider-handler-right");
    else $54b47fc030b7b21e$var$handler.classList.add("slider-handler-middle");
};
$54b47fc030b7b21e$var$updatePosition();
$54b47fc030b7b21e$var$range.addEventListener("input", $54b47fc030b7b21e$var$updatePosition);


//# sourceMappingURL=index.ae7eb614.js.map
